import * as React from 'react';
const SvgAutomagic = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.518 4.123c.37.19.63.86 1.14 2.2l1.12 2.9 2.9 1.12c1.34.51 2.01.77 2.2 1.14.17.32.17.71 0 1.03-.19.37-.86.63-2.2 1.14l-2.9 1.12-1.12 2.9c-.51 1.34-.77 2.01-1.14 2.2-.32.17-.7.17-1.03 0-.37-.19-.63-.86-1.14-2.2l-1.12-2.9-2.9-1.12c-1.34-.51-2.01-.77-2.2-1.14-.17-.32-.17-.71 0-1.03.19-.37.86-.63 2.2-1.14l2.9-1.12 1.12-2.9c.51-1.34.77-2.01 1.14-2.2.32-.17.7-.17 1.03 0M18.728 2.053c.16.08.28.38.5.96l.49 1.27 1.27.49c.58.22.88.34.96.5.07.14.07.31 0 .45-.08.16-.38.27-.96.5l-1.27.49-.49 1.27c-.22.58-.34.88-.5.96-.14.07-.31.07-.45 0-.16-.08-.28-.38-.5-.96l-.49-1.27-1.27-.49c-.58-.22-.88-.34-.96-.5a.5.5 0 0 1 0-.45c.08-.16.38-.27.96-.5l1.27-.49.49-1.27c.22-.58.34-.88.5-.96.14-.07.31-.07.45 0M17.728 15.053c.16.08.28.38.5.96l.49 1.27 1.27.49c.58.22.88.34.96.5.07.14.07.31 0 .45-.08.16-.38.27-.96.5l-1.27.49-.49 1.27c-.22.58-.34.88-.5.96-.14.07-.31.07-.45 0-.16-.08-.28-.38-.5-.96l-.49-1.27-1.27-.49c-.58-.22-.88-.34-.96-.5a.5.5 0 0 1 0-.45c.08-.16.38-.27.96-.5l1.27-.49.49-1.27c.22-.58.34-.88.5-.96.14-.07.31-.07.45 0"
    />
  </svg>
);
export default SvgAutomagic;
